import { render, staticRenderFns } from "./AddTipopessoaPage.vue?vue&type=template&id=14041d05&"
import script from "./AddTipopessoaPage.vue?vue&type=script&lang=js&"
export * from "./AddTipopessoaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports